(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jamos-cart-drawer"] && !Shopify.designMode) return;
  try {
    const initializeJamosCart = () => {
    const drawer = document.querySelector('[data-jamos-cart-drawer]');
    if (!drawer || drawer.dataset.bound === 'true') return;

    drawer.dataset.bound = 'true';
    const content = drawer.querySelector('[data-jamos-cart-drawer-content]');
    const footer = drawer.querySelector('[data-jamos-cart-drawer-footer]');
    const subtotal = drawer.querySelector('[data-jamos-cart-drawer-subtotal]');
    const status = drawer.querySelector('[data-jamos-cart-drawer-status]');
    const closeButton = drawer.querySelector('[data-jamos-cart-drawer-close]');
    const root = drawer.dataset.root;
    const currency = drawer.dataset.currency || 'USD';

    const request = async (url, options = {}) => {
      const response = await fetch(url, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json', ...(options.headers || {}) },
        ...options
      });
      if (!response.ok) throw new Error(`Cart request failed (${response.status})`);
      return response.json();
    };

    const handling = drawer.dataset.handlingEnabled === 'true'
      ? window.createJamosHandlingFee({ variantId: Number(drawer.dataset.handlingVariant), request, root }) : null;
    const getCart = () => handling ? handling.sync() : request(`${root}cart.js`);
    const transact = (operation) => handling ? handling.transact(operation) : operation().then(getCart);
    const itemCount = (cart) => handling ? handling.merchandiseCount(cart) : cart.item_count;
    const formatMoney = (amount, cartCurrency = currency) => new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: cartCurrency
    }).format((Number(amount) || 0) / 100);

    const announce = (message, isError = false) => {
      status.textContent = message;
      status.dataset.status = isError ? 'error' : 'success';
    };

    const updateHeaderCount = (count) => {
      document.querySelectorAll('[data-jamos-cart-count]').forEach((countElement) => {
        countElement.textContent = count;
        countElement.hidden = count === 0;
      });
    };

    const createElement = (tagName, className, text) => {
      const element = document.createElement(tagName);
      if (className) element.className = className;
      if (text) element.textContent = text;
      return element;
    };

    const renderCart = (cart) => {
      document.querySelector('[data-handling-error-notice]')?.remove();
      content.replaceChildren();
      updateHeaderCount(itemCount(cart));

      if (!itemCount(cart)) {
        const empty = createElement('div', 'jamos-cart-drawer__empty');
        empty.append(createElement('p', 'jamos-cart-drawer__empty-mark', 'J'));
        empty.append(createElement('p', 'jamos-cart-drawer__empty-copy', drawer.dataset.emptyMessage));
        content.append(empty);
        footer.hidden = true;
        return;
      }

      const listHeader = createElement('div', 'jamos-cart-drawer__list-header');
      listHeader.append(createElement('span', '', drawer.dataset.productLabel));
      listHeader.append(createElement('span', '', drawer.dataset.totalLabel));
      content.append(listHeader);

      const list = createElement('div', 'jamos-cart-drawer__items');
      cart.items.forEach((item) => {
        if (handling && handling.isFee(item)) return;
        const itemRow = createElement('article', 'jamos-cart-drawer__item');
        const itemImage = document.createElement('a');
        itemImage.className = 'jamos-cart-drawer__image';
        itemImage.href = item.url;
        itemImage.setAttribute('aria-label', item.product_title);

        if (item.image) {
          const image = document.createElement('img');
          image.src = item.image;
          image.alt = item.image_alt || item.product_title;
          image.width = 180;
          image.height = 180;
          image.loading = 'eager';
          itemImage.append(image);
        }
        itemRow.append(itemImage);

        const details = createElement('div', 'jamos-cart-drawer__details');
        const title = document.createElement('a');
        title.href = item.url;
        title.textContent = item.product_title;
        details.append(title);

        Object.entries(item.properties || {}).forEach(([key, value]) => {
          if (!value || key.charAt(0) === '_') return;
          details.append(createElement('p', 'jamos-cart-drawer__property', `${key}: ${value}`));
        });

        const priceRow = createElement('div', 'jamos-cart-drawer__price-row');
        const unitPrice = createElement('p', 'jamos-cart-drawer__unit-price');
        if (item.original_price > item.final_price) {
          unitPrice.append(createElement('s', '', formatMoney(item.original_price, cart.currency)));
        }
        unitPrice.append(createElement('span', '', formatMoney(item.final_price, cart.currency)));
        priceRow.append(unitPrice);
        const selectedOptions = (item.options_with_values || [])
          .map((option) => option.value)
          .filter((value) => value && value !== 'Default Title')
          .join(', ') || (item.variant_options || [])
          .filter((value) => value && value !== 'Default Title')
          .join(', ') || item.variant_title;
        if (selectedOptions && selectedOptions !== 'Default Title') {
          priceRow.append(createElement('p', 'jamos-cart-drawer__size', `${drawer.dataset.sizeLabel}: ${selectedOptions}`));
        }
        details.append(priceRow);

        const controls = createElement('div', 'jamos-cart-drawer__controls');
        const quantityControl = createElement('div', 'jamos-cart-drawer__quantity');
        const decrease = createElement('button', '', '−');
        decrease.type = 'button';
        decrease.dataset.jamosCartDrawerChange = item.key;
        decrease.dataset.quantity = String(Math.max(0, item.quantity - 1));
        decrease.setAttribute('aria-label', drawer.dataset.decreaseLabel.replace('%PRODUCT%', item.product_title));
        const quantity = createElement('span', '', String(item.quantity));
        quantity.setAttribute('aria-label', drawer.dataset.quantityLabel.replace('%PRODUCT%', item.product_title));
        const increase = createElement('button', '', '+');
        increase.type = 'button';
        increase.dataset.jamosCartDrawerChange = item.key;
        increase.dataset.quantity = String(item.quantity + 1);
        increase.setAttribute('aria-label', drawer.dataset.increaseLabel.replace('%PRODUCT%', item.product_title));
        quantityControl.append(decrease, quantity, increase);
        controls.append(quantityControl);

        const remove = createElement('button', 'jamos-cart-drawer__remove');
        remove.type = 'button';
        remove.dataset.jamosCartDrawerChange = item.key;
        remove.dataset.quantity = '0';
        remove.setAttribute('aria-label', drawer.dataset.removeLabel.replace('%PRODUCT%', item.product_title));
        const removeStrokeOne = document.createElement('span');
        removeStrokeOne.setAttribute('aria-hidden', 'true');
        const removeStrokeTwo = document.createElement('span');
        removeStrokeTwo.setAttribute('aria-hidden', 'true');
        remove.append(removeStrokeOne, removeStrokeTwo);
        if (item.properties && item.properties._jamos_automatic_gift) {
          remove.setAttribute('data-jamos-promotion-gift-remove', '');
        }
        controls.append(remove);
        details.append(controls);
        itemRow.append(details);

        const lineTotal = createElement('p', 'jamos-cart-drawer__line-total');
        lineTotal.textContent = formatMoney(item.final_line_price, cart.currency);
        itemRow.append(lineTotal);
        list.append(itemRow);
      });
      content.append(list);
      const fee = handling && cart.items.find(handling.isFee);
      drawer.querySelector('[data-handling-row]').hidden = !fee;
      if (fee) drawer.querySelector('[data-handling-total]').textContent = formatMoney(fee.final_line_price, cart.currency);
      const discounts = drawer.querySelector('[data-handling-discounts]');
      discounts.replaceChildren();
      (cart.cart_level_discount_applications || []).forEach((discount) => {
        const row = createElement('div', 'jamos-cart-drawer__subtotal');
        row.append(createElement('span', '', discount.title), createElement('span', '', `−${formatMoney(discount.total_allocated_amount, cart.currency)}`));
        discounts.append(row);
      });
      subtotal.textContent = formatMoney(cart.total_price, cart.currency);
      footer.hidden = false;
    };

    const openDrawer = (cart, message) => {
      renderCart(cart);
      if (message) announce(message);
      drawer.classList.remove('is-closing');
      if (!drawer.open) drawer.showModal();
      closeButton.focus();
    };

    const closeDrawer = () => {
      if (!drawer.open || drawer.classList.contains('is-closing')) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        drawer.close();
        return;
      }
      drawer.classList.add('is-closing');
      const finishClose = (event) => {
        if (event.target !== drawer) return;
        drawer.classList.remove('is-closing');
        drawer.close();
        drawer.removeEventListener('animationend', finishClose);
      };
      drawer.addEventListener('animationend', finishClose);
    };

    const updateLine = async (key, quantity) => {
      try {
        announce(drawer.dataset.updatingMessage);
        const cart = await transact(() => request(`${root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity })
        }));
        renderCart(cart);
        announce(drawer.dataset.updatedMessage);
      } catch (error) {
        console.error('Cart drawer update failed.', error);
        announce(drawer.dataset.errorMessage, true);
      }
    };

    drawer.querySelectorAll('[data-jamos-cart-drawer-close]').forEach((button) => {
      button.addEventListener('click', closeDrawer);
    });
    drawer.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeDrawer();
    });

    drawer.addEventListener('click', (event) => {
      if (event.target === drawer) {
        closeDrawer();
        return;
      }

      const changeButton = event.target.closest('[data-jamos-cart-drawer-change]');
      if (!changeButton) return;
      updateLine(changeButton.dataset.jamosCartDrawerChange, Number(changeButton.dataset.quantity));
    });

    document.addEventListener('jamos:cart-updated', async (event) => {
      try {
        const cart = await getCart();
        openDrawer(cart, event.detail?.message || drawer.dataset.addedMessage);
      } catch (error) { showHandlingError(error); }
    });

    document.addEventListener('submit', async (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || event.defaultPrevented) return;
      if (!form.querySelector('[name="id"]')) return;

      const submitter = event.submitter;
      if (submitter && submitter.closest('.shopify-payment-button')) return;

      event.preventDefault();
      if (submitter) submitter.disabled = true;
      try {
        announce(drawer.dataset.addingMessage);
        const data = new FormData(form);
        Array.from(data.keys()).filter((key) => key.startsWith('shopify-additional-items[')).forEach((key) => data.delete(key));
        const cart = await transact(() => request(form.action, { method: 'POST', body: data }));
        openDrawer(cart, drawer.dataset.addedMessage);
      } catch (error) {
        console.error('Cart drawer add failed.', error);
        showHandlingError(error);
      } finally {
        if (submitter) submitter.disabled = false;
      }
    });
    const showHandlingError = (error) => {
      console.error('Cart preparation failed.', error);
      let notice = document.querySelector('[data-handling-error-notice]');
      if (!notice) {
        notice = document.createElement('p');
        notice.dataset.handlingErrorNotice = '';
        notice.setAttribute('role', 'alert');
        notice.style.cssText = 'position:fixed;bottom:1rem;left:1rem;right:1rem;padding:1rem;background:#741e2b;color:white;z-index:10000';
        document.body.append(notice);
      }
      notice.textContent = drawer.dataset.handlingError;
    };
    if (handling) {
      document.addEventListener('submit', async (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement) || new URL(form.action, location.href).pathname !== `${root}cart`) return;
        event.preventDefault();
        if (form.dataset.handlingBusy) return;
        form.dataset.handlingBusy = 'true';
        const checkout = event.submitter?.name === 'checkout';
        const buttons = Array.from(form.querySelectorAll('button[type="submit"]'));
        buttons.forEach((button) => { button.disabled = true; });
        try {
          const data = new FormData(form);
          data.delete('checkout');
          data.delete('update');
          const cart = await transact(() => request(`${root}cart/update.js`, { method: 'POST', body: data }));
          if (checkout && itemCount(cart)) location.assign(`${root}checkout`);
          else location.assign(`${root}cart`);
        } catch (error) {
          showHandlingError(error);
          buttons.forEach((button) => { button.disabled = false; });
          delete form.dataset.handlingBusy;
        }
      }, true);
      const refreshFee = async () => {
        try {
          const before = await request(`${root}cart.js`);
          const cart = await getCart();
          updateHeaderCount(itemCount(cart));
          const changed = JSON.stringify(before.items.map((item) => [item.key, item.quantity])) !== JSON.stringify(cart.items.map((item) => [item.key, item.quantity]));
          if (location.pathname === `${root}cart` && changed) location.reload();
          else if (drawer.open) renderCart(cart);
        } catch (error) { showHandlingError(error); }
      };
      refreshFee();
      window.addEventListener('pageshow', (event) => { if (event.persisted) refreshFee(); });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeJamosCart, { once: true });
  else initializeJamosCart();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jamos-guarantee-presentation"] && !Shopify.designMode) return;
  try {
    (() => {
    const update = () => {
      const header = document.querySelector('.jamos-alt-header');
      const height = header
        ? Array.from(header.querySelectorAll(':scope > .jamos-alt-header__notice, :scope > .jamos-alt-header__bar'))
            .reduce((sum, element) => sum + element.getBoundingClientRect().height, 0)
        : 0;
      document.querySelectorAll('.jamos-learn-more--guarantee_v1 .jamos-learn-more__guarantee-image').forEach((hero) => {
        hero.style.setProperty('--jamos-guarantee-hero-sticky-top', `${height}px`);
      });
    };
    let pending = false;
    const schedule = () => {
      if (pending) return;
      pending = true;
      requestAnimationFrame(() => { pending = false; update(); });
    };
    update();
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    document.addEventListener('shopify:section:load', schedule);
    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(schedule);
      document.querySelectorAll('.jamos-alt-header > .jamos-alt-header__notice, .jamos-alt-header > .jamos-alt-header__bar').forEach((element) => observer.observe(element));
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jamos-price"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jamos-price')) {
    customElements.define('jamos-price', class extends HTMLElement {
      connectedCallback() {
        if (!this.hasAttribute('data-live-price') || this.onVariantChange) return;
        this.productSection = this.closest('[data-product-section], [data-jamos-pdp], [data-jamos-all-american-product]');
        if (!this.productSection) return;
        this.onVariantChange = (event) => {
          const input = event.target;
          if (input.name !== 'id') return;
          if (input.type === 'radio' && !input.checked) return;
          const template = Array.from(this.querySelectorAll('[data-price-variant]')).find(item => item.dataset.priceVariant === input.value);
          if (template) this.querySelector('[data-price-content]').replaceChildren(template.content.cloneNode(true));
        };
        this.productSection.addEventListener('change', this.onVariantChange);
      }
      disconnectedCallback() {
        this.productSection?.removeEventListener('change', this.onVariantChange);
        this.onVariantChange = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jamos-sale-tag"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jamos-sale-tag')) {
    customElements.define('jamos-sale-tag', class extends HTMLElement {
      connectedCallback() {
        if (!this.hasAttribute('data-sale-variants') || this.onVariantChange) return;
        this.productSection = this.closest('[data-product-section], [data-jamos-pdp], [data-jamos-all-american-product]');
        if (!this.productSection) return;
        this.saleVariants = this.dataset.saleVariants.split(',');
        this.onVariantChange = (event) => {
          const input = event.target;
          if (input.name !== 'id') return;
          if (input.type === 'radio' && !input.checked) return;
          this.hidden = !this.saleVariants.includes(input.value);
        };
        this.productSection.addEventListener('change', this.onVariantChange);
      }
      disconnectedCallback() {
        this.productSection?.removeEventListener('change', this.onVariantChange);
        this.onVariantChange = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["promotion-cart-automation"] && !Shopify.designMode) return;
  try {
    (() => {
    const components = document.querySelectorAll('[data-jamos-promotion-cart-automation]');

    components.forEach((notice) => {
      const config = {
        qualifyingProductId: Number(notice.dataset.qualifyingProductId),
        qualifyingVariantIds: JSON.parse(notice.dataset.qualifyingVariantIds || '[]').map(Number),
        giftVariantId: Number(notice.dataset.giftVariantId),
        root: notice.dataset.root,
        giftRemovalKey: notice.dataset.giftRemovalKey,
        messages: {
          added: notice.dataset.messageAdded,
          addFailed: notice.dataset.messageAddFailed,
          checkFailed: notice.dataset.messageCheckFailed
        }
      };

      const cartUrl = `${config.root}cart.js`;
      const cartAddUrl = `${config.root}cart/add.js`;

      const showNotice = (message, isError = false) => {
        notice.textContent = message;
        notice.hidden = false;
        notice.dataset.status = isError ? 'error' : 'success';
      };

      const request = async (url, options = {}) => {
        const response = await fetch(url, {
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', ...(options.headers || {}) },
          ...options
        });
        if (!response.ok) throw new Error(`Cart request failed (${response.status})`);
        return response.json();
      };

      const getCart = () => request(cartUrl, { method: 'GET', headers: {} });
      const hasGift = (cart) => cart.items.some((item) => Number(item.variant_id) === config.giftVariantId);
      const hasQualifyingItem = (cart) => cart.items.some((item) => Number(item.product_id) === config.qualifyingProductId);
      const isQualifyingVariant = (variantId) => config.qualifyingVariantIds.includes(Number(variantId));
      const wasGiftRemoved = () => window.sessionStorage.getItem(config.giftRemovalKey) === 'true';
      const markGiftRemoved = () => window.sessionStorage.setItem(config.giftRemovalKey, 'true');

      const addGift = async () => {
        await request(cartAddUrl, {
          method: 'POST',
          body: JSON.stringify({
            items: [{
              id: config.giftVariantId,
              quantity: 1,
              properties: { _jamos_automatic_gift: 'true' }
            }]
          })
        });
      };

      const ensureGift = async () => {
        const cart = await getCart();
        if (!hasQualifyingItem(cart)) {
          window.sessionStorage.removeItem(config.giftRemovalKey);
          return false;
        }
        if (hasGift(cart) || wasGiftRemoved()) return false;
        await addGift();
        showNotice(config.messages.added);
        return true;
      };

      document.addEventListener('click', (event) => {
        const removalLink = event.target.closest('[data-jamos-promotion-gift-remove]');
        if (removalLink) markGiftRemoved();
      });

      document.addEventListener('submit', async (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement)) return;

        const variantInput = form.querySelector('[name="id"]');
        if (!variantInput || !isQualifyingVariant(variantInput.value)) return;

        const submitter = event.submitter;
        if (submitter && submitter.closest('.shopify-payment-button')) return;

        event.preventDefault();
        try {
          const cart = await getCart();
          const quantityInput = form.querySelector('[name="quantity"]');
          const quantity = Math.max(1, Number(quantityInput ? quantityInput.value : 1) || 1);
          const items = [{ id: Number(variantInput.value), quantity }];

          if (!hasGift(cart) && !wasGiftRemoved()) {
            items.push({
              id: config.giftVariantId,
              quantity: 1,
              properties: { _jamos_automatic_gift: 'true' }
            });
          }

          await request(cartAddUrl, {
            method: 'POST',
            body: JSON.stringify({ items })
          });
          const updatedCart = await getCart();
          document.dispatchEvent(new CustomEvent('jamos:cart-updated', {
            detail: { cart: updatedCart }
          }));
        } catch (error) {
          console.error('Promotion gift insertion failed.', error);
          showNotice(config.messages.addFailed, true);
        }
      });

      ensureGift().catch((error) => {
        console.error('Promotion gift check failed.', error);
        showNotice(config.messages.checkFailed, true);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
